import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";
import moment from "moment";

class FamilyMembersList extends Component {

  mapLivingTogether = (livingTogether)  => {
    if(livingTogether === true) return 'Yes';
    if(livingTogether === false) return 'No';

    return '';
  }

  render() {
    const { action } = this.props;
    const familyMembers = this.props.familyMembers.filter((o) => !o._destroy);

    return (
      <Table size="sm" responsive>
        <thead>
          <tr>
            <th>Name</th>
            <th>Age</th>
            <th>Relation</th>
            <th>Gender</th>
            <th>Does family member live with client</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {familyMembers.map((o) => {
            return (
              <tr key={o.id}>
                <td>{o.name}</td>
                <td>{moment().diff(o.birthdate, "years")}</td>
                <td>{o.relationship}</td>
                <td>{o.gender}</td>
                <td>{this.mapLivingTogether(o.living_together)}</td>
                <td>
                  {action === "edit" && (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.editFamilyMember(o);
                      }}
                    >
                      Edit
                    </a>
                  )}
                </td>
              </tr>
            );
          })}
          {action == "edit" && (
            <tr>
              <td colSpan={7} className="text-center">
                <Button
                  variant="link"
                  onClick={() => {
                    this.props.newFamilyMember();
                  }}
                >
                  Add Family Member
                </Button>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    );
  }
}

const mapStateToProps = (state, _) => {
  return {
    isStaffApp: state.config.isStaffApp,
    familyMembers: state.family_members,
    action: state.ui.action,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    newFamilyMember: () => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName: "familyMember" },
      });
    },
    editFamilyMember: (resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: { resourceName: "familyMember", resource },
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FamilyMembersList);
